import { useState as o, useCallback as e } from "react";
import { useDropzone as r } from "react-dropzone";
const t = 10, n = 10485760, p = ({ onChange: t2 }) => {
  const [p2, l] = o(null), [s, c] = o(false), i = e((o2) => {
    if (o2.length > 0) {
      const e2 = o2[0];
      l(e2), t2(e2);
    }
  }, [t2]), { getRootProps: g, getInputProps: m } = r({ onDrop: i, multiple: false, maxSize: n, onDropAccepted: () => c(false), onDropRejected: (o2) => {
    const [e2] = o2;
    console.log(e2.errors), c(true);
  } });
  return { removeFile: () => {
    l(null), t2(null);
  }, getRootProps: g, getInputProps: m, selectedFile: p2, isDropzoneError: s };
};
export {
  t as MAX_DOWNLOAD_FILE_SIZE,
  n as MAX_FILE_SIZE,
  p as useCustomDropzone
};
//# sourceMappingURL=useCustomDropzone.js.map
